// extracted by mini-css-extract-plugin
export default {"root":"root--_DUWq","title":"title--JxCp0","divider":"divider--Hvrg6","dividerIsDark":"dividerIsDark--zC8UQ","btnWrap":"btnWrap--ZubZg","body":"body--EvjDq"};